import React       from 'react';
import ReactDom    from 'react-dom';
import Moment      from 'moment';

import Const       from 'fw_const';
import Utils       from 'utils';
import {Tooltip}        from 'pui-react-tooltip';
import {OverlayTrigger} from 'pui-react-overlay-trigger';

// -------------------------------------------------------


class Day extends React.Component {
  mouseOver(id) {
    try {
      let result = document.getElementsByClassName('work');
      for( let i in result ){
        let ele = result[i];
        if( ele.dataset.id == id ) ele.classList.add('work-hover');
      }
    } catch(e) {}
  }
  // -------------------------------------------------------
  
  mouseLeave() {
    try {
      let result = document.getElementsByClassName('work');
      for( let i in result ) result[i].classList.remove('work-hover');
    } catch(e) {}
  }
  // -------------------------------------------------------
  
  render() {
    let no = this.props.no;
    let day = this.props.day;
    let date = this.props.date;
    let mode = this.props.mode;
    let works = this.props.works;
    
    let to_month = (Moment(date).format('YYYY-MM') == Moment(day).format('YYYY-MM')) ? 'to_month' : 'not-target';
    let is_today = (Moment().format('YYYY-MM-DD') == Moment(day).format('YYYY-MM-DD')) ? 'today' : '';
    
    return (
      <div className="day">
        <p className={'day-number '+ to_month +' '+ is_today +' day_'+ Moment(day).day()}>{Moment(day).format('DD')}</p>
        
        { works.map((d, key) => {
          if( d.space === true ) return <div key={key} className="work-space" />
          if( d.mode == 'dashboard' ) return <DayDashboard key={key} no={no} day={day} data={d} date={date} works={works} mouseOver={this.mouseOver.bind(this)} mouseLeave={this.mouseLeave.bind(this)} />
          if( d.mode == 'workflow' ) return <DayWorkflow key={key} no={no} day={day} data={d} date={date} works={works} mouseOver={this.mouseOver.bind(this)} mouseLeave={this.mouseLeave.bind(this)} />;
          return null;
        })}
      </div>
    );
    
    //if( mode == 'dashboard' ){
      //return <DayDashboard no={no} day={day} date={date} works={works} mouseOver={this.mouseOver.bind(this)} mouseLeave={this.mouseLeave.bind(this)} />;
    //}
    //if( mode == 'workflow' ){
      //return <DayWorkflow no={no} day={day} date={date} works={works} mouseOver={this.mouseOver.bind(this)} mouseLeave={this.mouseLeave.bind(this)} />;
    //}
    
  }
}
// -------------------------------------------------------

class DayDashboard extends React.Component {
  render() {
    let d = this.props.data;
    let day = this.props.day;
    let date = this.props.date;
    let works = this.props.works;
    
    let work_data = Const.value.schedule_works[d.act];
    if( d.original_name != null){
      work_data = { name: d.original_name, icon: 'task_alt', color: '#f0b354' };
    } else {
      if( work_data == undefined || Object.keys(work_data).length == 0 ) return null;
    }
    
    // タイトル設定
    let title = <span><b className="work-title">{work_data.name}</b><b className="project-name"> | {d.project.title}</b></span>;
    
    // サイズ設定
    let work_size = (d.diff + 1);
    let week_size = (7 - this.props.no);
    let title_width = (work_size < week_size) ? (work_size * 110) : (week_size * 110);
    
    // リンク設定
    let link = '/project/'+ d.project.unique_code
    if( d.link != undefined ) link = d.link;
    
    return (
      <OverlayTrigger placement="top" delayShow={150} overlay={<Tooltip>{title}</Tooltip>}>
        <a href={link}>
          <div className={'work '+ d.type} data-id={d.id} onMouseEnter={this.props.mouseOver.bind(this, d.id)} onMouseLeave={this.props.mouseLeave.bind(this)}>
            <div className={'work-background '+ d.type} style={{ background: work_data.color }} />
            { (d.type == 'st' || d.type == 'st_ed') &&
              <div className="st-contents">
                <p className="work-title" style={{ width: 'calc('+ title_width +'% - 40px)' }}>
                  <i className="material-icons" style={{ color: work_data.color }}>{work_data.icon}</i>{title}
                </p>
              </div>
            }
          </div>
        </a>
      </OverlayTrigger>
    );
  }
}
// -------------------------------------------------------

class DayWorkflow extends React.Component {
  render() {
    let d = this.props.data;
    let day = this.props.day;
    let date = this.props.date;
    let works = this.props.works;
    
    let work_data = Const.value.schedule_workflow[d.act];
    if( work_data == undefined || Object.keys(work_data).length == 0 ) return null;
    
    // タイトル設定
    let title = <span><b className="work-title">{work_data.name}</b><b className="project-name"> | @{d.insta_id}</b></span>;
    
    // サイズ設定
    let work_size = (d.diff + 1);
    let week_size = (7 - this.props.no);
    let title_width = (work_size < week_size) ? (work_size * 110) : (week_size * 110);
    
    return (
      <OverlayTrigger placement="top" delayShow={150} overlay={<Tooltip>{title}</Tooltip>}>
        <a onClick={d.show_event.bind(this, d.insta_user_id)}>
          <div className={'work '+ d.type} data-id={d.id} onMouseEnter={this.props.mouseOver.bind(this, d.id)} onMouseLeave={this.props.mouseLeave.bind(this)}>
            <div className={'work-background '+ d.type} style={{ background: work_data.color }} />
            { (d.type == 'st' || d.type == 'st_ed') &&
              <div className="st-contents">
                <p className="work-title" style={{ width: 'calc('+ title_width +'% - 40px)' }}>
                  <img src={d.thumbnail} />{title}
                </p>
              </div>
            }
            
            { (d.is_checked == true) && <p className="checked"><i className="material-icons">check_circle</i></p> }
          </div>
        </a>
      </OverlayTrigger>
    );
  }
}
// -------------------------------------------------------

// レンダリング処理
export default Day;